<!-- Fora do `LayoutComponent`: a classe de versão vem da diretiva. -->
<main class="public-screen" appAccountVersionTheme>
  <div class="public-card">
    <div class="brand-bar"></div>
    <div class="public-card-body">
      <div class="logo">
        <img src="/assets/logo-smsfunnel-login.png" alt="SMS Funnel" title="SMS Funnel" />
      </div>
      <form class="public-form" [formGroup]="passwordResetForm" (submit)="changePassword()">
        <p class="screen-label">Recuperar senha</p>
        <p class="screen-hint">
          Informe o e-mail da sua conta e enviaremos as instruções para criar
          uma nova senha.
        </p>

        <div class="form-group mt-4">
          <label for="email">Email</label>
          <input type="email" data-testid="input-email-login" class="form-control" id="email" name="email" formControlName="email" #inputEmail />
        </div>
        <div class="form-group d-grid">
          <button type="submit" class="btn btn-primary" [appLoadingButton]="isLoading" data-testid="btn-login">
            Recuperar
          </button>
        </div>
        <div class="public-links">
          <a [routerLink]="['/']">
            Efetuar login
            <i class="fa fa-chevron-right"></i>
          </a>
        </div>
      </form>
    </div>
  </div>
</main>
